module.exports = __webpack_public_path__ + "341ebbae28e4caac6d0e4b3675b33723.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/p-peel/clear.png
 ** module id = 474
 ** module chunks = 0
 **/